{
  "action": {
    "ok": "OK",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "saved": "Enregistré",
    "close": "Fermer",
    "yes": "Oui",
    "no": "Non",
    "delete": "Supprimer",
    "remove": "Retirer",
    "add": "Ajouter",
    "edit": "Modifier",
    "rename": "Renommer",
    "retry": "Réessayer",
    "reset": "Réinitialiser",
    "apply": "Appliquer",
    "confirm": "Confirmer",
    "back": "Retour",
    "next": "Suivant",
    "done": "Terminé",
    "refresh": "Actualiser",
    "copy": "Copier",
    "copied": "Copié",
    "open": "Ouvrir",
    "start": "Démarrer",
    "stop": "Arrêter",
    "pause": "Pause",
    "resume": "Reprendre",
    "continue": "Continuer",
    "clear": "Effacer",
    "search": "Rechercher",
    "loading": "Chargement…",
    "saving": "Enregistrement…",
    "searchPlaceholder": "Rechercher…",
    "always": "Toujours",
    "deny": "Refuser",
    "undo": "Annuler",
    "all": "Tous"
  },
  "confirm": {
    "title": "Approbation requise : {{tool}}",
    "descriptionEdit": "L'agent souhaite modifier un fichier. Examinez la demande ci-dessous et décidez s'il faut poursuivre.",
    "descriptionTool": "L'agent souhaite exécuter cet outil. Examinez la demande ci-dessous et décidez s'il faut poursuivre.",
    "fileModification": "Modification de fichier",
    "toolExecution": "Exécution d'outil",
    "riskSuffix": "Risque {{risk}}",
    "command": "Commande",
    "inputLabel": "Entrée :",
    "trustSuggestionTitle": "Suggestion de motif de confiance",
    "trustSuggestionHint": "Choisir Toujours ajoutera les appels correspondants à la liste blanche pour ce projet.",
    "yoloDestructiveNote": "YOLO est activé. Cette confirmation s'affiche encore car la requête a été classée comme destructrice.",
    "skipApprovalsTitle": "Ignorer les futures approbations",
    "skipApprovalsHint": "Activez le mode YOLO et l'agent agit sans demander. Les opérations destructrices continuent de demander confirmation.",
    "enableYoloTitle": "Activer le mode YOLO (auto-approuver cet appel et les futurs appels non destructeurs)",
    "enableYoloBtn": "Activer YOLO",
    "denyAlways": "Toujours refuser",
    "denyAlwaysTitle": "Refuser cet appel et tous les futurs appels correspondant au motif (d)",
    "noTitle": "Refuser cet appel unique (Échap / n)",
    "alwaysTitle": "Approuver et mémoriser le motif pour le projet (a)",
    "yesTitle": "Approuver cet appel unique (y)"
  },
  "status": {
    "connected": "Connecté",
    "disconnected": "Déconnecté",
    "connecting": "Connexion…",
    "reconnecting": "Reconnexion…",
    "ready": "Prêt",
    "error": "Erreur",
    "offline": "Hors ligne",
    "online": "En ligne",
    "live": "En direct",
    "budgetWarning": "alerte budget",
    "running": "En cours",
    "inProgress": "En cours",
    "working": "travaille"
  },
  "time": {
    "justNow": "à l'instant",
    "secondsAgo_one": "il y a {{count}} seconde",
    "secondsAgo_other": "il y a {{count}} secondes",
    "minutesAgo_one": "il y a {{count}} minute",
    "minutesAgo_other": "il y a {{count}} minutes",
    "hoursAgo_one": "il y a {{count}} heure",
    "hoursAgo_other": "il y a {{count}} heures",
    "daysAgo_one": "il y a {{count}} jour",
    "daysAgo_other": "il y a {{count}} jours",
    "compactSecondsAgo": "il y a {{count}} s",
    "compactMinutesAgo": "il y a {{count}} min",
    "compactHoursAgo": "il y a {{count}} h"
  },
  "error": {
    "title": "Une erreur est survenue",
    "body": "Une erreur de rendu s'est produite. Votre session est toujours active sur le serveur — recharger reprendra là où vous étiez.",
    "reload": "Recharger la page",
    "tryAgain": "Réessayer"
  },
  "sparkline": {
    "noActivity": "Aucune activité",
    "noActivityYet": "Pas encore d'activité",
    "activityMax": "Sparkline d'activité : max {{count}} événements",
    "activityPeak": "Sparkline d'activité — pic {{count}} événements/intervalle"
  }
}
